/*
 * @Description: 路由
 * @Date: 2024-12-23 09:59:27
 */
export const route = [
  {
    path: '/main/form-manage-list',
    name: 'form-manage-list',
    meta: {
      title: '表单管理'
    },
    component: () => import('../views/form-manage-list/index')
  }
];
